import React, { useState } from 'react';
import { MdOutlineFileUpload } from 'react-icons/md';
import { Button } from '../ui/button';
import { IoLogOutOutline } from 'react-icons/io5';
import { renderField } from '../../helpers/form-validations';
import { Field, Form } from 'react-final-form';
import { Label } from '../ui/label';
import { FaRegEdit } from 'react-icons/fa';
import ResetPasswordDialog from '../ui/resetPasswordDialogComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { nullUserDetails, setUserDetails, updateUserImageUrl } from '../../context/actions/userAction';
import { loaderSet } from '../../context/actions/loaderAction';
import { changeUserProfilePic } from '../../utils/util';
import { alertDanger, alertSuccess } from '../../context/actions/toastAction';


const Profile = () => {
  const [isResetPasswordDialogOpen, setIsResetPasswordDialogOpen] = useState(false);
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const userInfo=useSelector(state=>state.user)
  const [profileImage, setProfileImage] = useState(null);

  const handleLogout=()=>{
    dispatch(loaderSet(true))
    dispatch(nullUserDetails())
    navigate("/")
    setTimeout(() => {
      dispatch(loaderSet(false))
    }, 3000);
  }



  const handleChangeUserProfilePic = async () => {
    dispatch(loaderSet(true));
    
    const payload = new FormData();
    payload.append("email", userInfo?.email);
    payload.append("user_id", userInfo?.user_id);

    if (profileImage) {
      payload.append("file", profileImage);  // Pass the file object directly
    }
    
    try {
      const response = await changeUserProfilePic(payload);

      if(response.code===200){
        console.log("Response for change profile image", response.data)
        dispatch(updateUserImageUrl(response.data.image_url));
        dispatch(alertSuccess("Changed the profile picture successfully"));
        dispatch(loaderSet(false));
        return
      }
      // if(response.code===400)
      else
      {

        dispatch(alertDanger(response?.errors?.length > 0 ? response?.errors[0] : response?.message || response?.error || "Failed to change profile picture"));
        dispatch(loaderSet(false));
        return
      }
    } catch (error) {
      console.log("Error in handleChangeUserProfilePic function", error);
      dispatch(loaderSet(false));
    } 
    // finally {
    //   dispatch(loaderSet(false));
    // }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file); // Save the file object in state
    }
  };

  // Call the API after setting the file state, using `useEffect` to watch for profileImage updates
  React.useEffect(() => {
    if (profileImage) {
      handleChangeUserProfilePic();
      console.log("PROFILE PIC IMAGE",profileImage)
    }
  }, [profileImage]);


  const initialValues = {
    name: userInfo?.user_name || '',
    email: userInfo?.email || '',
    userType: userInfo?.user_type || '',
    phoneNumber: userInfo?.mobile_number || '',
  };

  const onSubmit=async()=>{
    return
  }
  return (
    <>
      <div className="flex min-h-screen w-full flex-col bg-muted/40 px-6">
     <div className='flex flex-col gap-10  mt-4 '  >
     <h1 className="text-2xl font-bold text-[#0D215C]">Profile</h1>
     <div className="flex justify-between pr-5">
     <div className="flex items-center gap-4">
              {/* Profile Image */}
              <div className="relative w-20 h-20">
              <img
   src={ userInfo && userInfo.image_url ? userInfo.image_url :  "../avatar.png"}
  alt="Profile"
  className="w-full h-full rounded-full object-cover border border-gray-300"
/>

                <label htmlFor="profile-image-upload" className="absolute bottom-0 right-0 w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer" aria-label="Change profile image">
                  <MdOutlineFileUpload size={16} className="text-[#0D215C]" />
                  <input
                    id="profile-image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </label>
              </div>
              Change Profile Image
            </div>

          <Button type="button" onClick={handleLogout} className="rounded-lg w-36 border-none h-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-sm flex items-center justify-between">
            Logout
            <IoLogOutOutline className="text-white font-bold" size={20} /> {/* Adjusted size */}
          </Button>
        </div>
        <Form
        initialValues={initialValues}
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
<div className="gap-10 flex flex-col w-full">
    <div className="gap-2 flex flex-col md:flex-row w-full">
      <div className="gap-2 w-full md:w-[49%] flex flex-col ">

         <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="name">Name</Label>
      <Field
        id="name"
        type="text"
        name="name"
        placeholder="Name"
        // actionType={actionType}
        readOnly
        aria-disabled="true"
        // disabled={actionType==="View" && true}
        // validate={composeValidators(required)}
        component={renderField} // Correct usage of renderField
        className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] text-slate-700 manrope-fontCss"
      />
      {/* Reserve space for the error message */}

        </div>
        <div className="gap-2 w-full md:w-[49%] flex flex-col ">

<Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="email">Email</Label>
<Field
id="email"
type="text"
name="email"
placeholder="Email"
// actionType={actionType}
readOnly
aria-disabled="true"
// disabled={actionType==="View" && true}
// validate={composeValidators(required)}
component={renderField} // Correct usage of renderField
className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] text-slate-700 manrope-fontCss"
/>
{/* Reserve space for the error message */}
 
</div>
    </div>
    <div className="gap-2 flex flex-col md:flex-row w-full">
      <div className="gap-2 w-full md:w-[49%] flex flex-col ">

         <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="userType">User Type</Label>
      <Field
        id="userType"
        type="text"
        name="userType"
        placeholder="User Type"
      readOnly
      aria-disabled="true"
        // actionType={actionType}
       
        // disabled={actionType==="View" && true}
        // validate={composeValidators(required)}
        component={renderField} // Correct usage of renderField
        className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] text-slate-700 manrope-fontCss"
      />
      {/* Reserve space for the error message */}

        </div>
        <div className="gap-2 w-full md:w-[49%] flex flex-col ">

<Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="phoneNumber">Phone Number</Label>
<Field
id="phoneNumber"
type="text"
name="phoneNumber"
placeholder="Phone Number"
readOnly
aria-disabled="true"
// actionType={actionType}

// disabled={actionType==="View" && true}
// validate={composeValidators(required)}
component={renderField} // Correct usage of renderField
className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] text-slate-700 manrope-fontCss"
/>
{/* Reserve space for the error message */}
 
</div>
    </div>
    <div className="gap-2 flex flex-row w-full justify-between pr-5">
    <Button 
  type="button" 
  onClick={() => setIsResetPasswordDialogOpen(true)} // Corrected onClick syntax
      className="rounded-lg w-36 border-none h-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-sm flex items-center justify-between"
>
  Reset Password
</Button>
    {/* <Button className="rounded-lg w-36 border-none h-10 focus:ring-0 text-sm flex items-center justify-between">
            Edit
            <FaRegEdit className="text-white font-bold" size={20} /> 
          </Button> */}
    </div>
</div>
      
   </form> )}
   />

{isResetPasswordDialogOpen && (
            <ResetPasswordDialog
              onClose={() => setIsResetPasswordDialogOpen(false)}
            />
          )}

     </div>
      </div>
    </>
  );
};

export default Profile;
